export default __webpack_public_path__ + "static/media/logo-web-gateway.27c88a55.png";